<template>
  <v-autocomplete
      :key="currentStore?.id"
      v-model="currentStore"
      :custom-filter="customFilter"
      :items="stores"
      :placeholder="t('placeholder')"
      data-cy="store-selector"
      hide-details="auto"
      item-title="name"
      item-value="id"
      return-object
      variant="outlined"
      density="compact"
      color="primary">
    <template #item="{item, props}">
      <v-list-item v-bind="props" :title=" item?.raw?.id+' - '+item?.raw?.name" density="compact"/>
    </template>
    <template #selection="{item}">
      {{ item?.raw?.name }} - {{ useFormattedId(item?.raw?.id) }}
    </template>
  </v-autocomplete>
</template>

<script lang="ts" setup>

import type {Country} from "~/types/countries";
import type {DecathlonStore} from "~/types/decathlonStore";
import {useFormattedId} from "~/composables/UseFormattedId";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const currentStore = defineModel<DecathlonStore>()
const stores = ref()
const decathStore = useDecathlonStores()


const {selectedCountry} = defineProps<{
  selectedCountry: Country | undefined
}>()

watch(() => selectedCountry, async (country: Country) => {
  if (country)
    stores.value = await decathStore.fetchDecathlonStores(country)
}, {immediate: true})

const customFilter = (_: string, queryText: string, item?: any) => (
    item.raw.name.toLowerCase().includes(queryText.toLowerCase()) ||
    item.raw.id.toString().toLowerCase().includes(queryText.toLowerCase())
)

</script>

<i18n>
fr:
  placeholder: Choisir un magasin
en:
  placeholder: Choose your store
</i18n>
